import React from 'react';

import styled from '@emotion/styled';
import { mq, green01, baseDurationTime } from '../../_style';
import { Link } from 'gatsby';

const Container = styled.a`
  display: inline-block;
  font-size: 14px;
  position: relative;
  line-height: 1;
  letter-spacing: 0.2em;
  transition: color ${baseDurationTime} ease;
  ${mq.pc} {
    text-align: center;
  }
  ${mq.sp} {
    padding-left: 18px;
  }
  &:hover {
    color: ${green01};
  }
  span {
    line-height: 1;
    letter-spacing: 0.04em;
  }
  svg {
    display: inline-block;
    width: 12px;
    height: 10px;
    margin-left: 15px;
  }
`;

export default class BtnBlank extends React.Component {
  render() {
    return (
      <Container href={this.props.href} target="_blank">
        <span>{this.props.children}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10">
          <path stroke="#00ab84" strokeLinejoin="round" fill="none" d="M2.5.5h10v7h-10z"/>
          <path d="M10.5 9.5H.5v-7" stroke="#21bc80" fill="none"/>
        </svg>
      </Container>
    );
  }
}
